// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_33974c2b58--tooltip--Rln6T","arrow":"_33974c2b58--arrow--GMnRq"};